/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef, useContext, useEffect, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { styled, Typography } from "@mui/material";

import { EnergyUnitPrefixContext } from "@core/index";
import { formatNumberForUnitMainLabel } from "@core/utils";

const Root = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",

  "& .up-icon": {
    // Using a simple class name
    marginTop: "-8.5px",
  },

  "& .down-icon": {
    // Using a simple class name
    marginBottom: "-1rem",
  },
}));

const isValue = (value: any) =>
  value !== undefined &&
  value !== null &&
  value !== "" &&
  value !== "NaN" &&
  // eslint-disable-next-line no-restricted-globals
  !isNaN(value) &&
  value !== Infinity;

// eslint-disable-next-line import/no-default-export
export default forwardRef(
  (
    {
      suffix,
      value,
      prefix,
      default_up = true,
      color = "secondary",
      energyUnitPrefix,
      variant = "labelLarge",
      ...restProps
    }: any,
    ref
  ) => {
    const [selectedColor, setSelectedColor] = useState<string>("secondary");
    const up = default_up ? value >= 0 : value > 0;
    const contextEnergyPrefix = useContext(EnergyUnitPrefixContext);
    const resolvedEnergyPrefix = energyUnitPrefix ?? contextEnergyPrefix;

    let mainNumber = "";
    let mainPrefix = prefix;
    let mainUnit = suffix;
    if (isValue(value)) {
      const result = formatNumberForUnitMainLabel(
        Math.abs(value),
        suffix,
        undefined,
        resolvedEnergyPrefix
      );
      mainNumber = result[0] ?? "";
      mainPrefix = result[2] ?? mainPrefix;
      mainUnit = result[3] ?? mainUnit;
    }

    useEffect(() => {
      // Sometimes color is an array, so we have to use the last element
      if (Array.isArray(color)) {
        setSelectedColor(color[color.length - 1]);
      } else {
        setSelectedColor(color);
      }
    }, [color]);

    return (
      <Root
        style={{ display: "flex" }} // Keep original style prop
        {...restProps}
        ref={ref}
      >
        {up ? (
          <div className="up-icon">
            {" "}
            {/* Use the new class name */}
            <ArrowDropUpIcon fontSize="large" data-testid="arrow-up" color={selectedColor as any} />
          </div>
        ) : (
          <div className="down-icon">
            {" "}
            {/* Use the new class name */}
            <ArrowDropDownIcon
              fontSize="large"
              data-testid="arrow-down"
              color={selectedColor as any}
            />
          </div>
        )}
        <Typography
          component="span"
          variant={variant}
          color={selectedColor}
          id="arrow-deviation-text"
        >
          {mainNumber} {`${mainPrefix}${mainUnit}`}
        </Typography>
      </Root>
    );
  }
);
